var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSms = function SvgSms(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "#2355FC",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1181_77699)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.8009 2.79894C9.87141 -0.130574 5.12987 -0.131014 2.19995 2.79894C-0.15581 5.15467 -0.600967 8.65746 0.791765 11.447L0.0196379 14.8433C-0.0807225 15.2848 0.314914 15.6806 0.756523 15.5802L4.15286 14.8081C9.0911 17.2736 14.9965 13.7041 14.9965 8.09945C14.9965 6.09723 14.2168 4.2148 12.8009 2.79894ZM9.06413 9.9661H4.37302C4.03297 9.9661 3.75731 9.69044 3.75731 9.35039C3.75731 9.01035 4.03297 8.73469 4.37302 8.73469H9.06413C9.40417 8.73469 9.67983 9.01035 9.67983 9.35039C9.67983 9.69044 9.40417 9.9661 9.06413 9.9661ZM10.6278 7.46419H4.37302C4.03297 7.46419 3.75731 7.18853 3.75731 6.84848C3.75731 6.50843 4.03297 6.23277 4.37302 6.23277H10.6278C10.9679 6.23277 11.2436 6.50843 11.2436 6.84848C11.2436 7.18853 10.9679 7.46419 10.6278 7.46419Z",
    fill: "inherit"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1181_77699"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white",
    transform: "translate(0 0.601562)"
  })))));
};
export default SvgSms;